<template>
  <div class="main">

    <refresh-list @onLoad="onLoad" :list="list" @onRefresh="init" ref="refreshList">
      <div class="card-content-lsy" v-for="(item, index) in list" :key="index">
        <div class="card-media">
          <van-image width="100%" height="130" :src="item.backgroundImg" fit="cover" />
          <div class="badge-text">活动id：{{item.activityId}}</div>
        </div>
        <div class="card-inner">
          <div class="card-title">{{item.activityTitle}}</div>
        </div>
        <div class="card-inner">
          <div class="card-text">
            <div>起止时间：{{item.startTime | shortDate}} 至 {{item.endTime | shortDate}}</div>
          </div>
        </div>
        <div class="card-inner">
          <div class="card-text grid-item">
            <div class="orange">{{item.browseNumber}}</div>
            <div class="desc">浏览次数</div>
          </div>
          <div class="card-text grid-item">
            <div class="orange">{{item.browsePeopleNumber}}</div>
            <div class="desc">浏览人数</div>
          </div>
          <div class="card-text grid-item">
            <div class="orange">{{item.shareNumber}}</div>
            <div class="desc">二次分享</div>
          </div>
          <div class="card-text grid-item">
            <div class="orange">{{item.signUpNumber}}</div>
            <div class="desc">报名人数</div>
          </div>
        </div>
        <div class="card-footer">
          <div v-if="isTeacher" class="card-btn link-item" @click="to(item, '/dealer')">
            <span class="desc">经销商</span>
            <span class="orange">({{item.dealerNumber}})</span>
          </div>
          <div v-if="isTeacher || isDistributor" class="card-btn link-item" @click="to(item, '/store')">
            <span class="desc">门店</span>
            <span class="orange">({{item.storeNumber}})</span>
          </div>
          <div v-if="isTeacher || isDistributor || isShopowner" class="card-btn link-item" @click="to(item, '/stuff')">
            <span class="desc">职员</span>
            <span class="orange">({{item.staffNumber}})</span>
          </div>
          <div v-if="isTeacher || isDistributor || isShopowner || isGuide" class="card-btn link-item" @click="to(item, '/user')">
            <span class="desc">用户</span>
            <span class="orange">({{item.customerNumber}})</span>
          </div>
        </div>
      </div>
    </refresh-list>
    
  </div>
</template>

<script>
import refreshList from '@/components/refresh-list/refresh-list'
import { mapGetters } from 'vuex'
export default {
  components: {
    refreshList
  },
  computed: {
    ...mapGetters([
      'isTeacher',
      'isDistributor',
      'isShopowner',
      'isGuide'
    ])
  },
  data() {
    return {
      list: [],
      pageNum: 1,
      pageSize: 20,
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    onLoad() {
      this.getList();
    },
    init() {
      this.pageNum = 1;
      this.list = [];
      this.getList();
    },
    getList() {
      let data = {
        filterData: {
          activityId: this.$route.query.activityId
        },
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      this.$api.h5.queryActivityStatisticList(data)
      .then(res=>{
        if(res.code == 200) {
          this.list.push(...res.data.list);
          this.pageNum = res.data.pageNum + 1;
          this.$refs['refreshList'].complete(res.data);
        }else{
          this.$refs['refreshList'].onFinish();
        }
      })
      .catch(err=>{
        this.$refs['refreshList'].onFinish();
      })
    },
    to(item, p) {
      this.$router.push({
        path: p,
        query: {
          activityId: item.activityId,
          activityTitle: item.activityTitle,
          enterType: item.enterType,
          enterPrimaryKey: item.enterPrimaryKey
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .main
    >>>.van-pull-refresh
      min-height 100vh
  .grid-item
    text-align center
    .orange
      color #FF6B31
      font-size 18px
      font-weight bold
    .desc
      font-size 12px
      color #666666

  .link-item
    .desc
      font-size 14px
      color #666666
    .orange
      color #FF6B31
      font-size 14px
</style>